export default "__VITE_PUBLIC_ASSET__254c70de__"